import React from 'react'
import { IconProps } from './types'
import { Flex } from '@chakra-ui/core'
import { List } from 'lucide-react'
import colors from 'constants/colors'

const PrivatePollIcon: React.FC<IconProps> = ({
  iconWidth = 24,
  iconHeight = 24,
  width = '40px',
  height = '40px',
  iconColor = '#FFF',
  bgColor = colors.privatePoll,
  ...props
}) => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      bg={bgColor}
      width={width}
      height={height}
      borderRadius="full"
      {...props}
    >
      <List width={iconWidth} height={iconHeight} color={iconColor} strokeWidth={3} />
    </Flex>
  )
}

export default PrivatePollIcon
